import { RouterPaths } from "../../../router/routerPaths";

export const globalSearchActions = [
    {
        id: "dashboard",
        name: "Dashboard",
        section: "Main",
        shortcut: ["d"],
        keywords: "dashboard home overview main",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.DASHBOARD),
    },
    {
        id: "administration",
        name: "Administration",
        section: "Administration",
        keywords: "admin administration management",
    },
    {
        id: "educational-institution",
        name: "Educational Institution",
        section: "Administration",
        keywords: "educational institution university school",
        parent: "administration",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.EDUACTIONALINSTITUTE),
    },
    {
        id: "institute-settings",
        name: "Institute Settings",
        section: "Administration",
        keywords: "institute settings configuration",
        parent: "administration",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.INSTITUTESETTINGS),
    },
    {
        id: "user-access-control",
        name: "User Access Control",
        section: "Administration",
        shortcut: ["u", "a", "c"],
        keywords: "user access control permissions security",
        parent: "administration",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.USERACCESSCONTROL),
    },
    {
        id: "role",
        name: "Roles",
        section: "Administration",
        keywords: "role roles permissions user management",
        parent: "administration",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.ROLE),
    },
    {
        id: "permissions",
        name: "Permissions",
        section: "Administration",
        keywords: "permissions access rights security",
        parent: "administration",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.PERMISSIONS),
    },
    {
        id: "expire-all-passwords",
        name: "Expire All Passwords",
        section: "Administration",
        keywords: "expire passwords security reset",
        parent: "administration",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.EXPIREALLPASSWORDS),
    },
    {
        id: "action-history",
        name: "Action History",
        section: "Administration",
        keywords: "action history audit log",
        parent: "administration",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.ACTIONHISTORY),
    },
    {
        id: "password-policies",
        name: "Password Policies",
        section: "Administration",
        keywords: "password policies security requirements",
        parent: "administration",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.PASSWORDPOLICIES),
    },
    {
        id: "institutional-preferences",
        name: "Institutional Preferences",
        section: "Administration",
        keywords: "institutional preferences settings configuration",
        parent: "administration",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.INSTITUTIONALPREFERENCES),
    },
    {
        id: "educational-settings",
        name: "Educational Settings",
        section: "Educational Settings",
        keywords: "educational settings academic configuration",
    },
    {
        id: "educational-degrees",
        name: "Educational Degrees",
        section: "Educational Settings",
        keywords: "educational degrees bachelor master phd",
        parent: "educational-settings",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.EDUCATIONALDEGREES),
    },
    {
        id: "learning-format",
        name: "Learning Format",
        section: "Educational Settings",
        keywords: "learning format online offline hybrid",
        parent: "educational-settings",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.LEARNINGFORMAT),
    },
    {
        id: "faculty",
        name: "Faculty",
        section: "Educational Settings",
        keywords: "faculty departments schools",
        parent: "educational-settings",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.FACULTY),
    },
    {
        id: "profession",
        name: "Profession",
        section: "Educational Settings",
        keywords: "profession career field study",
        parent: "educational-settings",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.PROFESSION),
    },
    {
        id: "academic-department",
        name: "Academic Department",
        section: "Educational Settings",
        keywords: "academic department faculty division",
        parent: "educational-settings",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.ACADEMICDEPARTMENT),
    },
    {
        id: "subject",
        name: "Subject",
        section: "Educational Settings",
        keywords: "subject course curriculum",
        parent: "educational-settings",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.SUBJECT),
    },
    {
        id: "academic-term",
        name: "Academic Term",
        section: "Educational Settings",
        keywords: "academic term semester quarter",
        parent: "educational-settings",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.ACADEMICTERM),
    },
    {
        id: "academic-year",
        name: "Academic Year",
        section: "Educational Settings",
        keywords: "academic year school year",
        parent: "educational-settings",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.ACADEMICYEAR),
    },
    {
        id: "study-years",
        name: "Study Years",
        section: "Educational Settings",
        keywords: "study years grade level",
        parent: "educational-settings",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.STUDYYEARS),
    },
    {
        id: "teaching-type",
        name: "Teaching Type",
        section: "Educational Settings",
        keywords: "teaching type lecture seminar lab",
        parent: "educational-settings",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.TEACHINGTYPE),
    },
    {
        id: "subject-check-type",
        name: "Subject Check Type",
        section: "Educational Settings",
        keywords: "subject check type assessment evaluation",
        parent: "educational-settings",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.SUBJECTCHECKTYPE),
    },
    {
        id: "baseline-data",
        name: "Baseline Data",
        section: "Educational Settings",
        keywords: "baseline data initial assessment",
        parent: "educational-settings",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.BASELINEDATA),
    },
    {
        id: "baseline-data-setting",
        name: "Baseline Data Setting",
        section: "Educational Settings",
        keywords: "baseline data setting configuration",
        parent: "educational-settings",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.BASELINEDATASETTING),
    },
    {
        id: "qualification",
        name: "Qualification",
        section: "Educational Settings",
        keywords: "qualification certification degree",
        parent: "educational-settings",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.QUALIFICATION),
    },
    {
        id: "modular-subject",
        name: "Modular Subject",
        section: "Educational Settings",
        keywords: "modular subject course modules",
        parent: "educational-settings",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.MODULARSUBJECT),
    },
    {
        id: "baseline",
        name: "Baseline",
        section: "Educational Settings",
        keywords: "baseline assessment initial",
        parent: "educational-settings",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.BASELINE),
    },
    {
        id: "educational-blocks",
        name: "Educational Blocks",
        section: "Educational Settings",
        keywords: "educational blocks structure organization",
        parent: "educational-settings",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.EDUCATIONALBLOCKS),
    },
    {
        id: "competences",
        name: "Competences",
        section: "Educational Settings",
        keywords: "competences skills abilities",
        parent: "educational-settings",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.COMPETENCES),
    },
    {
        id: "competences-settings",
        name: "Competences Settings",
        section: "Educational Settings",
        keywords: "competences settings configuration",
        parent: "educational-settings",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.COMPETENCESSETTINGS),
    },
    {
        id: "educational-sectors",
        name: "Educational Sectors",
        section: "Educational Settings",
        keywords: "educational sectors areas fields",
        parent: "educational-settings",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.EDUCATIONALSECTORS),
    },
    {
        id: "learning-management",
        name: "Learning Management",
        section: "Learning Management",
        keywords: "learning management courses curriculum",
    },
    {
        id: "learning-plan",
        name: "Learning Plan",
        section: "Learning Management",
        shortcut: ["l", "p"],
        keywords: "learning plan curriculum study program",
        parent: "learning-management",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.LEARNINGPLAN),
    },
    {
        id: "learning-plan-trash",
        name: "Learning Plan Restore",
        section: "Learning Management",
        keywords: "learning plan restore trash deleted",
        parent: "learning-management",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.LEARNINGPLANTRASH),
    },
    {
        id: "learning-plan-settings",
        name: "Learning Plan Settings",
        section: "Learning Management",
        keywords: "learning plan settings configuration",
        parent: "learning-management",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.LEARNINGPLANSETTINGS),
    },
    {
        id: "learning-plan-information",
        name: "Learning Plan Information",
        section: "Learning Management",
        keywords: "learning plan information details",
        parent: "learning-management",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.LEARNINGPLANINFORMATION),
    },
    {
        id: "hr",
        name: "HR Management",
        section: "HR",
        keywords: "hr human resources employees staff",
    },
    {
        id: "employees",
        name: "Employees",
        section: "HR",
        shortcut: ["e"],
        keywords: "employees staff personnel workers",
        parent: "hr",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.EMPLOYEES),
    },
    {
        id: "employees-settings",
        name: "Employees Settings",
        section: "HR",
        keywords: "employees settings configuration",
        parent: "hr",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.EMPLOYEESSETTINGS),
    },
    {
        id: "employees-overview",
        name: "Employees Overview",
        section: "HR",
        keywords: "employees overview summary statistics",
        parent: "hr",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.EMPLOYEESOVERVIEW),
    },
    {
        id: "roles-associations",
        name: "Roles Associations",
        section: "HR",
        keywords: "roles associations relationships mapping",
        parent: "hr",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.ROLESASSOCIATIONS),
    },
    {
        id: "academic-structure",
        name: "Academic Structure",
        section: "HR",
        keywords: "academic structure organization hierarchy",
        parent: "hr",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.ACADEMICSTRUCTURE),
    },
    {
        id: "workload",
        name: "Workload",
        section: "HR",
        keywords: "workload teaching hours assignments",
        parent: "hr",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.WORKLOAD),
    },
    {
        id: "workload-settings",
        name: "Workload Settings",
        section: "HR",
        keywords: "workload settings configuration",
        parent: "hr",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.WORKLOADSETTINGS),
    },
    {
        id: "academic-positions",
        name: "Academic Positions",
        section: "HR",
        keywords: "academic positions jobs titles",
        parent: "hr",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.ACADEMICPOSITIONS),
    },
    {
        id: "academic-scheduling",
        name: "Academic Scheduling",
        section: "HR",
        keywords: "academic scheduling timetable calendar",
        parent: "hr",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.ACADEMICSCHEDULING),
    },
    {
        id: "educational-duration",
        name: "Educational Duration",
        section: "HR",
        keywords: "educational duration length time",
        parent: "hr",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.EDUCATIONALDURATION),
    },
    {
        id: "baseline-items",
        name: "Baseline Items",
        section: "HR",
        keywords: "baseline items components elements",
        parent: "hr",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.BASELINEITEMS),
    },
    {
        id: "subject-groups",
        name: "Subject Groups",
        section: "HR",
        keywords: "subject groups categories collections",
        parent: "hr",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.SUBJECTGROUPS),
    },
    {
        id: "positions-working-hours",
        name: "Positions Working Hours",
        section: "HR",
        keywords: "positions working hours schedule time",
        parent: "hr",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.POSITIONSWORKINGHOURS),
    },
    {
        id: "students-management",
        name: "Student Management",
        section: "Students",
        keywords: "students management enrollment registration",
    },
    {
        id: "students",
        name: "Students",
        section: "Students",
        shortcut: ["s"],
        keywords: "students pupils learners",
        parent: "students-management",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.STUDENTS),
    },
    {
        id: "study-payment-options",
        name: "Study Payment Options",
        section: "Students",
        keywords: "study payment options fees tuition",
        parent: "students-management",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.STUDYPAYMENTOPTIONS),
    },
    {
        id: "students-settings",
        name: "Students Settings",
        section: "Students",
        keywords: "students settings configuration",
        parent: "students-management",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.STUDENTSSETTINGS),
    },
    {
        id: "students-overview",
        name: "Students Overview",
        section: "Students",
        keywords: "students overview summary statistics",
        parent: "students-management",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.STUDENTSOVERVIEW),
    },

    {
        id: "languages",
        name: "Languages",
        section: "Localization",
        keywords: "languages localization translation",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.LANGUAGES),
    },
    {
        id: "translations",
        name: "Translations",
        section: "Localization",
        keywords: "translations localization text",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.TRANSLATIONS),
    },

    {
        id: "united-lessons",
        name: "United Lessons",
        section: "Learning Management",
        keywords: "united lessons combined classes",
        parent: "learning-management",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.UNITEDLESSONS),
    },
    // {
    //     id: "united-item",
    //     name: "United Item",
    //     section: "Learning Management",
    //     keywords: "united item combined element",
    //     parent: "learning-management",
    //     perform: (navigate: (path: string) => void) => navigate(RouterPaths.UNITEDITEM),
    // },
    // {
    //     id: "workload-item",
    //     name: "Workload Item",
    //     section: "Learning Management",
    //     keywords: "workload item task assignment",
    //     parent: "learning-management",
    //     perform: (navigate: (path: string) => void) => navigate(RouterPaths.WORKLOADITEM),
    // },
    {
        id: "academic-structure-settings",
        name: "Academic Structure Settings",
        section: "Educational Settings",
        keywords: "academic structure settings configuration",
        parent: "educational-settings",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.ACADEMICSTRUCTURESETTINGS),
    },
    {
        id: "academic-week-setup",
        name: "Academic Week Setup",
        section: "Educational Settings",
        keywords: "academic week setup schedule configuration",
        parent: "educational-settings",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.ACADEMICWEEKSETUP),
    },
    {
        id: "elective-subjects",
        name: "Elective Subjects",
        section: "Educational Settings",
        keywords: "elective subjects optional courses",
        parent: "educational-settings",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.ELECTIVESUBJECTS),
    },
    // {
    //     id: "elective-item",
    //     name: "Elective Item",
    //     section: "Educational Settings",
    //     keywords: "elective item optional element",
    //     parent: "educational-settings",
    //     perform: (navigate: (path: string) => void) => navigate(RouterPaths.ELECTIVEITEM),
    // },
    {
        id: "non-working-days",
        name: "Non-Working Days",
        section: "Educational Settings",
        keywords: "non working days holidays calendar",
        parent: "educational-settings",
        perform: (navigate: (path: string) => void) => navigate(RouterPaths.NONWORKINGDAYS),
    },
];
